export type DeviceViewport = 'desktop' | 'tablet' | 'mobile';

export const DEVICE_VIEWPORT_WIDTHS: Record<Exclude<DeviceViewport, 'desktop'>, number> = {
  mobile: 390,
  tablet: 768,
};

/** Preview-only inset inside device frames. Not part of book style templates. */
export const DEVICE_PREVIEW_CONTENT_PADDING: Record<Exclude<DeviceViewport, 'desktop'>, number> = {
  mobile: 16,
  tablet: 24,
};

export function isNarrowDeviceViewport(viewport?: DeviceViewport): boolean {
  return viewport === 'mobile' || viewport === 'tablet';
}

export function getDeviceViewportWidth(viewport: DeviceViewport): number | undefined {
  if (viewport === 'desktop') return undefined;
  return DEVICE_VIEWPORT_WIDTHS[viewport];
}
